import React, { memo, useCallback, PropsWithChildren } from "react";
import { Label, List, Icon, Image as SUIImage } from "semantic-ui-react";

import SgFileUpload, { IFileUploadElementProps } from "./FileUpload";
import { IFileObj, EUploadStatus } from "../models/IFile";
import Image from './Image'
import Thumbnail from "./Thumbnail";


export interface IImageInputProps {
    files: { id: string; name: string }[]
    multiple?: boolean;
    onUploaded?: (newFiles: { id: string; name: string }[]) => void;
    onRemoved: (guid: string) => void;
    onInvalidFile?: (error: Error) => void;
    inputAreaElem: React.ComponentType<PropsWithChildren<IFileUploadElementProps>>;
    disabled?: boolean
}

const noop = () => undefined;

const ImageListItem: React.FC<{ file: IFileObj; onRemove: any }> = ({ file, onRemove }) => {
    const loading = [EUploadStatus.Uploading, EUploadStatus.Removing].includes(file.status)
    //  const complete = file.status === EUploadStatus.Done;
    //  const error = [EUploadStatus.RemoveError, EUploadStatus.UploadError].includes(file.status)
    if (file.guid) {
        return (
            <List.Item className="FileUpload_imageContainer">
                <Label
                    onClick={() => !loading && onRemove(file)}
                    color="black"
                    size="tiny"
                    style={{ cursor: "pointer" }}
                    floating circular>
                    <Icon fitted style={{ marginBottom: '-15px' }}  >
                        {loading ? <Icon name="spinner" loading /> : <Icon name="times" />}
                    </Icon>
                </Label>
                <Thumbnail id={file.guid} className="ImageList_img" thumbnailWidth={200} />
            </List.Item >
        )
    }

    return (
        <List.Item className="FileUpload_imageContainer">
            <SUIImage className="ImageList_img" src="/loading_placeholder.gif" />
        </List.Item>
    );

};

const ListWrapper: React.FC = ({ children }) => (
    <List horizontal className="ImageList"> {children} </List>
)


const ImageInput: React.FC<IImageInputProps> = (props) => {
    const {
        onUploaded = noop,
        onRemoved = noop,
        inputAreaElem,
        multiple,
        files,
        disabled
    } = props;

    const onUploadedCallback = useCallback((files: { id: string; name: string }[]) => {
        onUploaded(files);
    }, [onUploaded]);

    return (
        <SgFileUpload
            accept="image/*"
            multiple={multiple}
            onUploaded={onUploadedCallback}
            onRemoved={onRemoved}
            wrapElement={inputAreaElem}
            loaderElement={ImageListItem}
            listWrapperElement={ListWrapper}
            files={files}
            disabled={disabled}
        />
    );
};

export default memo(ImageInput);
